import {useMutation} from '@apollo/client';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  CreateTournamentForm,
  DialogProps,
  TournamentConditions,
} from 'packages/common-types/base-types';
import {Address, Tournament} from 'packages/common-types/schema-types';
import {CREATE_TOURNAMENT} from 'packages/graphql/v2/mutations';
import {GET_TOURNAMENTS} from 'packages/graphql/v2/queries';
import {FormProvider, useForm} from 'react-hook-form';
import Swal from 'sweetalert2';
import NewTournamentForm from './Form';

type MutationVars = {
  input: {
    name: string;
    /** Fecha de inicio del torneo */
    startDate: string;
    /** Fecha de finialización del torneo */
    finishDate: string;
    /** Lugar donde se va realizar el torneo */
    address: Address;
    /** Condiciones para crear el torneo */
    conditions: TournamentConditions;
    /** Si el torneo tiene final */
    hasFinal: boolean;
  };
};

type MutationData = {
  createTournament: Tournament;
};

type Props = DialogProps & {};

const NewTournament = (props: Props) => {
  const {toggle, modalOpen} = props;
  const methods = useForm<CreateTournamentForm>();

  const [createTournament, {loading: loadingTournament}] = useMutation<
    MutationData,
    MutationVars
  >(CREATE_TOURNAMENT);

  const onSubmit = async (formData: CreateTournamentForm) => {
    const {country, state, city, ...rest} = formData;
    const {
      finishDate,
      hasFinal,
      name,
      startDate,
      gender,
      modalityGame,
      numberOfRounds,
      pointLimit,
      tournamentType,
      tournamentCategory,
    } = rest;
    try {
      await createTournament({
        variables: {
          input: {
            finishDate,
            hasFinal,
            name,
            startDate,
            conditions: {
              gender,
              modalityGame,
              numberOfRounds: +numberOfRounds,
              pointLimit: +pointLimit,
              tournamentType,
              tournamentCategory,
            },
            address: {
              country,
              state,
              city,
            },
          },
        },
        refetchQueries: [
          {
            query: GET_TOURNAMENTS,
          },
        ],
      });
      methods.reset();
      Swal.fire({
        title: 'Hecho!',
        text: 'El torneo ha sido creado con éxito',
        icon: 'success',
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error!',
        text: 'Ha ocurrido un error al crear el torneo',
        icon: 'error',
      });
    } finally {
      toggle();
    }
  };

  return (
    <FormProvider {...methods}>
      <Dialog
        fullWidth
        id="new-tournament-dialog"
        maxWidth="sm"
        open={modalOpen}
        onClose={toggle}
        aria-labelledby="dialog-create-tournament"
      >
        <DialogTitle id="title-create-tournament">Crear un torneo</DialogTitle>
        {loadingTournament && <LinearProgress />}

        <DialogContent dividers>
          <NewTournamentForm onSubmit={onSubmit} />
        </DialogContent>
        <DialogActions>
          <Button onClick={toggle} color="default">
            Cancelar
          </Button>
          <Button type="submit" form="create-tournament-form" color="primary">
            Crear
          </Button>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
};

export default NewTournament;
